import React from 'react'
import SuperUserTxnPageUI from '../../../templates/SuperUserTxnPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI.js'
import ReconTxnListUI from '../../../components/superUser/nodalTxn/ReconTxnListUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'

const ReconTxnListPageUI = ({ context, errorList, accountNumber, transactionList, filteredTransactionList,
  selectedTxnId, on733Click, on441Click,
  year, month, yearList, monthList, onYearChange, onMonthChange,
  searchFilter, onSearchFilterChange, onRefreshClick,
  onCopyToClipboard, copyToClipboardText,
  onExternalClick, externalSubmitted, onCancelledClick, cancelledSubmitted,
  onUpdateRemarksClick, updateRemarksMode, onCancelRemarksClick, objectCode, objectId, selectedRemarks,
  transactionId, reconciliationStatus, nodalExtTxnTypeList,
  details, onDetailsClick
}) =>
  <SuperUserTxnPageUI context={context} className='pg_su_txn_l' topnav='transactions'
    headerText='Nodal transactions' centered={!transactionList && !errorList}
    page={accountNumber === '007105010733' ? '0733recon' : '4441recon'} dimension='w1600'
  >
    {
      !transactionList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }

    {
      transactionList &&
      <ReconTxnListUI context={context}
        accountNumber={accountNumber}
        transactionList={filteredTransactionList}
        onRefreshClick={onRefreshClick}
        on733Click={on733Click}
        on441Click={on441Click}
        yearList={yearList}
        monthList={monthList}
        year={year}
        month={month}
        onYearChange={onYearChange}
        onMonthChange={onMonthChange}
        selectedTxnId={selectedTxnId}
        searchFilter={searchFilter} onSearchFilterChange={onSearchFilterChange}
        onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
        onExternalClick={onExternalClick}
        externalSubmitted={externalSubmitted}
        onCancelledClick={onCancelledClick}
        cancelledSubmitted={cancelledSubmitted}
        onUpdateRemarksClick={onUpdateRemarksClick}
        updateRemarksMode={updateRemarksMode}
        onCancelRemarksClick={onCancelRemarksClick}
        objectCode={objectCode}
        objectId={objectId}
        selectedRemarks={selectedRemarks}
        transactionId={transactionId}
        reconciliationStatus={reconciliationStatus}
        nodalExtTxnTypeList={nodalExtTxnTypeList}
        details={details}
        onDetailsClick={onDetailsClick}
      />
    }
  </SuperUserTxnPageUI>

export default ReconTxnListPageUI
